import GraphicDesign from "../../assets/graphicdesign.png";
import VideoEditing from "../../assets/videoedit.png";
import SocialMediaManager from "../../assets/smm.png";
import VirtualAssistant from "../../assets/va.png";
import CustomerServiceRep from "../../assets/csr.png";
import CopyWriting from "../../assets/copywriting.png";
import ServicesCard from "../../components/ServicesCard";

const Offers = () => {
  return (
    <div className="-z-1 bg-bg-primary py-10 w-full px-8 sm:px-10 md:px-16 relative">
      <div className="">
        <p className="italic">Our offered</p>
        <h1 className="text-5xl font-black pb-4">SERVICES</h1>
      </div>
      <div className="h-96 w-96 bg-transparent-accent absolute top-40 right-52 z-1 blur-3xl brightness-75"></div>
      <div className="grid sm:grid-rows gap-4 sm:gap-x-4 md:grid-cols-3">
        <ServicesCard
          src={GraphicDesign}
          title="Graphic Design"
          text="Crafting precise visuals, our graphic designer tailors
                      each design to your brand, captivating your audience with
                      unique identity reflections.  "
        />
        <ServicesCard
          src={VideoEditing}
          title="Video Editing"
          text="Collaborate with the industries' professional video
                      editors to provide high quality videos for social media."
        />
        <ServicesCard
          src={SocialMediaManager}
          title="Social Media Management"
          text="Boost your online presence with skilled social media
                      management that creates engaging content,
                      fostering community engagement for brand success."
        />
        <ServicesCard
          src={VirtualAssistant}
          title="Virtual Assistant"
          text="Skilled assistants streamline tasks, saving time and
                      enhancing efficiency for a streamlined workload"
        />
        <ServicesCard
          src={CustomerServiceRep}
          title="Customer Service"
          text="Receive outstanding support from our customer service
                      representative that is ommitted to your satisfaction."
        />
        <ServicesCard
          src={CopyWriting}
          title="Copywriting"
          text="Enhance your brand story with our expert copywriter.
                      Crafting impactful content for websites, ads, we drive
                      engagement with precision."
        />
      </div>
    </div>
  );
};

export default Offers;
